import React from "react";
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import imageCb from './assets/images/CB.jpg';
import imageSepa from './assets/images/sepa.png';
import imageCheque from './assets/images/cheque.png';
import imageVirement from './assets/images/virement.png';
import { Button } from "react-bootstrap";

const Prix = ({ tarif, par, type, libelle, image }) => (
    <Card style={{ textAlign: "center", width: '18rem' }}>
        <Card.Img variant="top" src={image} style={{ width: "135px", margin: "auto", paddingTop: "10px" }} />
        <Card.Body>
            <Card.Title>{type}<br></br>{libelle}</Card.Title>
            <Card.Text>
                <Table style={{ margin: "auto", width: "auto" }}>
                    <thead style={{ textAlign: "start", borderColor: "transparent" }}>
                        <tr>
                            <td style={{ fontSize: "2.1em", fontWeight: "bold", paddingRight: "3px", width: "30px" }}>
                                {tarif}&nbsp;€
                            </td>
                            <td style={{ fontSize: "1em", fontWeight: "bold", paddingLeft: "0px", paddingTop: "15px", width: "30px", verticalAlign: "initial" }}>
                                HT
                            </td>
                            <td style={{ color: "gray", lineHeight: "16px", verticalAlign: "top", paddingTop: "17px", paddingLeft: "0px", width: "30px" }}>
                                <br></br>{par}
                            </td>
                        </tr>
                    </thead>
                </Table>
            </Card.Text>
        </Card.Body>
    </Card>
);



const Tarif = ({ prix, cotisation, code, mail, handleTarifSelected }) => {
    const url = localStorage.getItem('url');

    const handleSelPaiement = (paiement, nb) => {
        // alert(paiement + ' ' + nb + ' fois')
        handleTarifSelected({paiement, nb});
    }

    return (
        <Container>
            <Row>
                <Col style={{ textAlign: "-webkit-center" }}>
                    <form action={`${url}adhesion/${prix * 100}/${mail}/${code}`} method="POST">
                        <div>
                            <button type="submit" className="btn btn-primary">
                                <Prix tarif={prix} par="" type="Carte bancaire" libelle="" image={imageCb}></Prix>
                            </button>
                        </div>
                    </form>
                </Col>

                <Col style={{ textAlign: "-webkit-center" }}>
                    <Button variant="primary" onClick={() => handleSelPaiement('PRELEVEMENT', 1)}>
                        <Prix tarif={prix} par="" type="Prélèvement SEPA" libelle="" lien="semestre" image={imageSepa}></Prix>
                    </Button>
                </Col>
                {cotisation.trois_fois === 1 && <Col style={{ textAlign: "-webkit-center" }}>
                    <Button variant="primary" onClick={() => handleSelPaiement('PRELEVEMENT', 3)}>
                        <Prix tarif={prix} par="" type="Prélèvement SEPA" libelle="en 3 fois" lien="semestre" image={imageSepa}></Prix>
                    </Button>
                </Col>}
                {cotisation.six_fois === 1 && <Col style={{ textAlign: "-webkit-center" }}>
                    <Button variant="primary" onClick={() => handleSelPaiement('PRELEVEMENT', 6)}>
                        <Prix tarif={prix} par="" type="Prélèvement SEPA" libelle="en 6 fois" lien="semestre" image={imageSepa}></Prix>
                    </Button>
                </Col>}

                <Col style={{ textAlign: "-webkit-center" }}>
                    <Button variant="primary" onClick={() => handleSelPaiement('VIREMENT')}>
                        <Prix tarif={prix} par="" type="Virement" libelle="" lien="annee" image={imageVirement}></Prix>
                    </Button>
                </Col>

                {/* <Col style={{ textAlign: "-webkit-center" }}>
                    <Button variant="primary" onClick={() => handleSelPaiement('CHEQUE')}>
                        <Prix tarif={prix} par="" type="Cheque" libelle="" lien="annee" image={imageCheque}></Prix>
                    </Button>
                </Col> */}
            </Row>
        </Container>
    );
}

export default Tarif;